import React, { useCallback, useEffect, useState } from 'react';
import axios from 'axios';
import { useSelector } from 'react-redux';
import { Alert, Box, Button, Container, Dialog, DialogActions, DialogContent, DialogTitle, Paper, Stack, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography } from '@mui/material';
const money = (n) => `${Number(n || 0).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} DH`;
const localDay = (s) => new Intl.DateTimeFormat('en-CA', { timeZone: 'Africa/Casablanca', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(s.endsWith('Z') ? s : `${s}Z`));
const today = () => new Intl.DateTimeFormat('en-CA', { timeZone: 'Africa/Casablanca', year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date());
const dateFR = (s) => new Date(s.endsWith('Z') ? s : `${s}Z`).toLocaleString('fr-FR', { timeZone: 'Africa/Casablanca' });
export default function Depenses() {
  const user = useSelector((s) => s.userData);
  const base = `${process.env.REACT_APP_API_URL}caisse-depenses`;
  const auth = `${user.id}/${user.apitoken}`;
  const [data, setData] = useState({ solde: 0, items: [] });
  const [montant, setMontant] = useState('');
  const [motif, setMotif] = useState('');
  const [selected, setSelected] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const load = useCallback(async () => {
    try { const r = await axios.post(`${base}/depenses/${auth}`, {}, { timeout: 20000 }); setData(r.data); }
    catch (e) { setError(e.response?.data?.detail || 'Chargement impossible'); }
  }, [base, auth]);
  useEffect(() => { load(); }, [load]);
  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setError(''); setSuccess('');
    try {
      await axios.post(`${base}/depense/ajouter/${auth}`, { montant, motif }, { timeout: 20000 });
      setMontant(''); setMotif(''); setSuccess('Dépense enregistrée'); await load();
    } catch (e) { setError(e.response?.data?.detail || 'Enregistrement impossible'); }
    finally { setBusy(false); }
  };
  const remove = async () => {
    if (!selected) return;
    setBusy(true); setError(''); setSuccess('');
    try { await axios.post(`${base}/depense/supprimer/${auth}/${selected.id}`, {}, { timeout: 20000 }); setSelected(null); setSuccess('Dépense supprimée et solde restitué'); await load(); }
    catch (e) { setError(e.response?.data?.detail || 'Suppression impossible'); setSelected(null); }
    finally { setBusy(false); }
  };
  return <Container maxWidth="lg" sx={{ mt: 5, mb: 5 }}>
    <Typography variant="h5" align="center" gutterBottom>Dépenses de caisse</Typography>
    <Paper sx={{ p: 3, mb: 3 }}><Typography color="text.secondary">Solde disponible</Typography><Typography variant="h4">{money(data.solde)}</Typography></Paper>
    {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
    {success && <Alert severity="success" sx={{ mb: 2 }}>{success}</Alert>}
    <Paper component="form" onSubmit={submit} sx={{ p: 3, mb: 3 }}>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
        <TextField required label="Montant (DH)" value={montant} onChange={(e) => setMontant(e.target.value)} inputProps={{ inputMode: 'decimal' }} />
        <TextField required fullWidth label="Désignation / motif" value={motif} onChange={(e) => setMotif(e.target.value)} />
        <Button disabled={busy} type="submit" variant="contained">Ajouter</Button>
      </Stack>
    </Paper>
    <Typography variant="h6" gutterBottom>Historique des dépenses</Typography>
    <Paper sx={{ overflowX: 'auto' }}><Table size="small"><TableHead><TableRow sx={{ backgroundColor: '#222' }}>
      {['Date', 'Motif', 'Montant', 'Action'].map((x) => <TableCell key={x} sx={{ color: '#fff' }}>{x}</TableCell>)}
    </TableRow></TableHead><TableBody>{data.items.map((x) => <TableRow key={x.id}>
      <TableCell>{dateFR(x.date)}</TableCell><TableCell>{x.motif}</TableCell><TableCell>{money(x.montant)}</TableCell>
      <TableCell>{(user.type === 'admin' || (localDay(x.date) === today() && x.auteur_id === user.id)) && <Button color="error" disabled={busy} onClick={() => setSelected(x)}>Supprimer</Button>}</TableCell>
    </TableRow>)}{!data.items.length && <TableRow><TableCell colSpan={4}>Aucune dépense</TableCell></TableRow>}</TableBody></Table></Paper>
    <Dialog open={!!selected} onClose={() => !busy && setSelected(null)}><DialogTitle>Confirmer la suppression</DialogTitle>
      <DialogContent>Le montant de {money(selected?.montant)} sera restitué au solde de la caisse.</DialogContent>
      <DialogActions><Button disabled={busy} onClick={() => setSelected(null)}>Annuler</Button><Button disabled={busy} color="error" onClick={remove}>Supprimer</Button></DialogActions>
    </Dialog>
  </Container>;
}
